// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2-err","search":"Settings_search__2obf-","filter":"Settings_filter__3Z0QJ"};